import {action, extendObservable} from 'mobx';
import {FETCH_URL} from "../constants/ServerLinks";

class World {

    constructor({world = []}, worldId) {

        extendObservable(this, world);
        this.apiUrl = FETCH_URL + '/api/v1/worlds/parameters/?world_id=' + worldId.toString();
    }

    @action
    fetchWorld = async () => {
        const response = await fetch(`${this.apiUrl}`);
        const db_world = await response.json();
        this.world = db_world.data;
    };

}

export default World;
